import { Quill } from 'react-quill-new';
var BaseImageFormat = Quill.import('formats/image');
var imageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style',
    'relativeWidth',
];
// Quill 2's `formats/image` blot is a genuine native ES6 class. Our build
// compiles this file down to ES5 (ts-loader target: 'es5'), whose downleveled
// `class ... extends` calls the parent constructor via `.apply()` instead of
// `new`/`Reflect.construct` — that throws "Class constructor Image cannot be
// invoked without 'new'" for a real native class. `node_modules` (including
// quill) is excluded from the ES5 downlevel, so it keeps its native class as-is.
// Using a plain function + Reflect.construct sidesteps the broken downlevel.
function ImageFormat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Reflect.construct(BaseImageFormat, args, ImageFormat);
}
Object.setPrototypeOf(ImageFormat, BaseImageFormat);
ImageFormat.prototype = Object.create(BaseImageFormat.prototype, {
    constructor: {
        value: ImageFormat,
        enumerable: false,
        writable: true,
        configurable: true,
    },
});
Object.assign(ImageFormat, {
    formats: function (domNode) {
        var _a, _b, _c;
        var width = domNode.width || domNode.offsetWidth || domNode.clientWidth;
        var richTextWidth = (_c = (_b = (_a = domNode === null || domNode === void 0 ? void 0 : domNode.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode) === null || _c === void 0 ? void 0 : _c.offsetWidth;
        var height = domNode.height || domNode.offsetHeight || domNode.clientHeight;
        var existingHeight = domNode.getAttribute('height');
        var existingWidth = domNode.getAttribute('width');
        domNode.onload = function () {
            if (height === 0)
                height = domNode.height;
            if (width === 0)
                width = domNode.width;
        };
        if (!existingHeight || height.toString() !== existingHeight) {
            domNode.setAttribute('height', height);
        }
        if (!existingWidth || width.toString() !== existingWidth) {
            domNode.setAttribute('width', width);
            domNode.setAttribute('relativeWidth', richTextWidth);
        }
        return imageFormatAttributesList.reduce(function (formats, attribute) {
            if (attribute === 'height' || attribute === 'width') {
                // when adding an Image for react native to render height should be there
                if (!isNaN(height) && height > 0) {
                    formats['height'] = height;
                }
                // when adding an Image for react native to render width should be there
                if (!isNaN(width) && width > 0) {
                    formats['width'] = width;
                    formats['relativeWidth'] = richTextWidth;
                }
            }
            else if (domNode.hasAttribute(attribute)) {
                // react native does not support float, so we had to manually remove float and use block and margin for alignment
                if (attribute === 'style') {
                    var styles = domNode.getAttribute('style');
                    var newStyles = styles;
                    if (styles.includes('float: right;')) {
                        newStyles = newStyles.replace('float: right;', 'margin-left: auto !important;');
                    }
                    if (styles.includes('float: left;')) {
                        newStyles = newStyles.replace('float: left;', 'margin-right: auto !important;');
                    }
                    newStyles = newStyles.replace('display: inline;', 'display: block;');
                    formats['style'] = newStyles;
                }
                else {
                    formats[attribute] = domNode.getAttribute(attribute);
                }
            }
            return formats;
        }, {});
    },
});
ImageFormat.prototype.format = function format(name, value) {
    if (imageFormatAttributesList.indexOf(name) > -1) {
        if (value) {
            this.domNode.setAttribute(name, value);
        }
        else {
            this.domNode.removeAttribute(name);
        }
    }
    else {
        BaseImageFormat.prototype.format.call(this, name, value);
    }
};
export default ImageFormat;
